import { useParams } from "react-router-dom";

import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";
import { getEntityNameFromPayload, getVersionNumber } from "../utils";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { getItemLink } from "@/components/UnifiedRegistry/utils";
import { ActionType, ChangelogEntry, Entity } from "@/queries/folder-entities/types";

const CreateVersionEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.CREATE_VERSION>>();
  const versionNumber = getVersionNumber(event);
  const payload = event.action_payload;

  const entityName = getEntityNameFromPayload(event.entity_type, payload);

  const { workspaceId } = useParams();

  if (!versionNumber || !event.entity_id) {
    return (
      <ActionText>
        <span>Version #{versionNumber}</span> created
      </ActionText>
    );
  }

  const link = getItemLink(
    {
      id: event.entity_id,
      type: event.entity_type,
      version_number: event.action_payload?.dataset_id ?? versionNumber,
    } as Entity,
    Number(workspaceId),
  );

  return (
    <EventTitleWrapper>
      <ActionText>Created</ActionText>
      <EntityLink type={event.entity_type} name={entityName} version={versionNumber} link={link} />
    </EventTitleWrapper>
  );
};

export default CreateVersionEventTitle;
